import TextField, { TextFieldProps } from '@components/v2/form/TextField/TextField';
import type { InputBaseComponentProps, OutlinedInputProps } from '@mui/material';
import { type RefCallback, forwardRef } from 'react';
import MaskedInput from 'react-text-mask';
import type { Mask } from 'react-text-mask/index';

const MaskedTextInput = forwardRef<HTMLElement, InputBaseComponentProps>(
  ({ mask, ...props }, inputRef) => (
    <MaskedInput
      {...props}
      mask={mask as Mask}
      ref={(instance) => {
        const inputElement =
          (instance as unknown as { inputElement?: HTMLInputElement } | null)?.inputElement ?? null;
        (inputRef as RefCallback<HTMLInputElement | null>)?.(inputElement);
      }}
    />
  ),
);

MaskedTextInput.displayName = 'MaskedTextInput';

type Props = TextFieldProps & {
  mask: Mask | ((value: string) => Mask);
};

const MaskField = forwardRef<HTMLInputElement, Props>(({ mask, slotProps, ...props }, ref) => (
  <TextField
    {...props}
    ref={ref}
    slotProps={{
      ...slotProps,
      input: {
        ...(slotProps?.input as OutlinedInputProps),
        inputComponent: MaskedTextInput as unknown as OutlinedInputProps['inputComponent'],
      },
      htmlInput: { ...(slotProps?.htmlInput as object), mask } as InputBaseComponentProps,
    }}
  />
));

MaskField.displayName = 'MaskField';
export type { Props as MaskFieldProps };
export default MaskField;
